module.exports = __webpack_public_path__ + "img/voss-logo.5ecd169d.png";